<template>
  <div v-show="isShowBanner" class="mint-swiper">
    <div class="swiper-banner">
      <van-swipe :autoplay="4000" indicator-color="white">
        <van-swipe-item v-for="(item, i) in banners" :key="i">
          <img :src="item.img" class="banner" @click="onclick(item)">
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>

<script>
import {Swipe, SwipeItem} from 'vant'
import {mapGetters} from 'vuex'
export default {
  name: 'SwipeBanner',
  components: {
    SwipeItem, Swipe
  },
  props: {
    list: {
      type: Array,
      default: () => null
    }
  },
  data: function () {
    return {
      mySwiper: {},
      activityIndex: 0
    }
  },
  computed: {
    ...mapGetters('Channel', [
      'getChannelData'
    ]),
    banners () {
      if (this.list) return this.list
      if (this.getChannelData && this.getChannelData.banners) {
        return this.getChannelData.banners.filter((item) => {
          if (item.bannerPlace === this.$dataResource.bannerType.header || item.bannerPlace === this.$dataResource.bannerType.header + '') return true
        })
      }
    },
    isShowBanner () {
      return !!(this.banners && this.banners.length > 0)
    }
  },
  mounted () {
  },
  methods: {
    onclick (item) {
      console.log('item', item)
      this.$utils.checkCanGoRouter(item.url)
      this.$emit('onClick', item)
    }
  }
}
</script>

<style scoped lang="scss">
  .mint-swiper{
    width: 100%;
    // padding-top: $padding;
    background: url(https://cdn.51ljb.cn/BG.png) no-repeat;
    background-size: 100% 90%;
  }
  .swiper-banner{
    width: 345px;
    height: 140px;
    margin: 0 auto;
    padding-top: 30px;
  }
  .banner-item{
    padding-top: $padding;
    background: white;
    position: relative;
  }
  .banner {
    display: block;
    height: 100%;
    width: 100%;
    border-radius: 5px;
  }

  .swiper-container{
    width: 100%;
    height: 150px;
    background-color: white;
  }
  .swiper-slide{
    width: 339px ;

  }
  .swiper-slide-prev {
    height: 120px !important;
    margin-top:15px !important;
  }
  .swiper-slide-next  {
    height: 120px !important;
    margin-top:15px !important;
  }

  .dis-wrapper{
    z-index: 2;
    bottom: 6px;
    width: 100%;
    position: absolute;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-items: center;
    align-content: center;
    justify-content: center;
  }
  .dis-slide{
    width: 12px;
    height: 3px;
    border-radius: 2px;
    margin: 2px;
    background-color: $mask-background-color;
  }
  .dis-slide-act{
    background-color: $base-color;
  }
  /deep/.mint-swipe-indicators{
    bottom: 6px;
  }
  /deep/.mint-swipe-indicator{
    width: 5px;
    height: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/swiper/SwipeBannerNew.vue